import { merge } from 'ramda';
import { TActions } from '../../types';
import { PUBLISH_OFFER_START } from '../publishInfo';
import { SAVE_OFFER_DRAFT, UPDATE_OFFER } from './actions';
import { EOfferStatus, IOfferState } from './types';

const initialState: Partial<IOfferState> = {
  photos: [],
};

export function offer(state: IOfferState, action: TActions) {
  switch (action.type) {
    case UPDATE_OFFER:
      return merge(state, action.payload);

    case SAVE_OFFER_DRAFT:
      return {
        ...state,
        status: EOfferStatus.draft,
      };

    case PUBLISH_OFFER_START:
      return {
        ...state,
        status: EOfferStatus.published,
      };

    default:
      return state || initialState;
  }
}
